import React from 'react';
import { TextField, Box, Typography, List, ListItem, ListItemButton, ListItemText, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import './AutoSuggestList.css';

const AutoSuggestList = ({
  label, placeholder,
  searchValue,
  onSearch,
  items = [],
  selectedItem,
  onSelect,
  disabled = false,
  type
}) => {

  return (
    <Box className="autoSuggestContainer">
      <TextField
        label={placeholder}
        size="small"
        fullWidth
        value={searchValue}
        onChange={(e) => onSearch(e.target.value)}
        disabled={disabled}
        className="autoSuggestInput"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
      <Box className="autoSuggestListBox">
        {items.length === 0 ? (
          <Box className="autoSuggestNoData">
            <Typography variant="body2" color="text.secondary">
              No Data
            </Typography>
          </Box>
        ) : (
          <List dense>
            {items.map((item) => (
              <ListItem key={item.id || item.library_id || item.cell_id || item.view_id} disablePadding>
                <ListItemButton
                  selected={
                    (type === 'library' && selectedItem?.library_id === item.library_id) ||
                    (type === 'cell' && selectedItem?.cell_id === item.cell_id) ||
                    (type === 'view' && selectedItem?.view_id === item.view_id)
                  }
                  onClick={() => onSelect(item)}
                >
                  <ListItemText primary={item.name} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        )}
      </Box>
    </Box>
  );
};

export default AutoSuggestList;